<div pias-layout-content>
  @if(this.setSprinner()) {
  <div class="pias-spinner">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  }
  <br />
  <div class="content">
    <div class="bdm-assessment-container" [formGroup]="assessmentForm">
      <h6 class="page-header">DM ASSESSMENT FORM FOR NEW REPRESENTATIVE</h6>
      <h5 class="field-title">Information on New Representative</h5>
      <div class="row">
        <!-- Branch Name -->
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">store</mat-icon> -->
            Name of New Representative (as in NRIC/Passport)
          </label>

          <mat-form-field class="w-100">
            <input matInput formControlName="name" placeholder="Enter Name" readonly />
          </mat-form-field>
        </div>

        <!-- Financial Services Director -->
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">star</mat-icon> -->
            Recruiting Manager
          </label>

          <mat-form-field class="w-100">
            <input matInput formControlName="manager" placeholder="Enter Recruiting Manager" readonly />
          </mat-form-field>
        </div>
        <!-- </div> -->
      </div>
      <h5 class="field-title">Recruitment Questionnaires</h5>
      <div class="check-list">
        <ol class="custom-list">
          <li>
            <div class="row">
              <div class="col-sm-10">
                <span>Is the applicant referred by any of our representatives?</span>
              </div>

              <div class="col-sm-2">
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_1')?.value === true"
                  (change)="onCheckboxChange($event.checked, true,'recruitmentQuestionnaires_1',1)">Yes</mat-checkbox>
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_1')?.value === false"
                  (change)="onCheckboxChange($event.checked, false,'recruitmentQuestionnaires_1',1)">No</mat-checkbox>
              </div>

              @if (assessmentForm.get('recruitmentQuestionnaires_1')?.value === true) {
              <div class="row g-3">
                <mat-label>If Yes, please state the Referrer’s Name and PIAS Code</mat-label>
                <div class="mt-2">
                  <mat-form-field class="w-100">
                    <input matInput formControlName="recruitmentQuestionnairesyes_1_1"
                      placeholder="Enter Referrer's Name" />
                    @if(this.assessmentForm.controls["recruitmentQuestionnairesyes_1_1"].invalid
                    && (this.assessmentForm.controls["recruitmentQuestionnairesyes_1_1"].touched)
                    ) {
                    <mat-error>
                      @if(this.assessmentForm.controls["recruitmentQuestionnairesyes_1_1"].errors?.["required"]) {
                      <span>{{message}}</span>
                      }
                      @else {
                      <span></span>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="mt-2">
                  <mat-form-field class="w-100">
                    <input matInput formControlName="recruitmentQuestionnairesyes_1_2" placeholder="Enter Pias Code" />
                    @if(this.assessmentForm.controls["recruitmentQuestionnairesyes_1_2"].invalid
                    && (this.assessmentForm.controls["recruitmentQuestionnairesyes_1_2"].touched)
                    ) {
                    <mat-error>
                      @if(this.assessmentForm.controls["recruitmentQuestionnairesyes_1_2"].errors?.["required"]) {
                      <span>{{message}}</span>
                      }
                      @else {
                      <span></span>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
              }
            </div>
            @if(this.assessmentForm.controls["recruitmentQuestionnaires_1"].invalid
            && (this.assessmentForm.controls["recruitmentQuestionnaires_1"].touched)
            ) {
            <mat-error>
              @if(this.assessmentForm.controls["recruitmentQuestionnaires_1"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </li>

          <li>
            <div class="row">
              <div class="col-sm-10">
                <span>Is the applicant on any Transition Allowance Scheme? </span>
              </div>
              <div class="col-sm-2">
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_2')?.value === true"
                  (change)="onCheckboxChange($event.checked, true,'recruitmentQuestionnaires_2',2)">Yes</mat-checkbox>
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_2')?.value === false"
                  (change)="onCheckboxChange($event.checked, false,'recruitmentQuestionnaires_2',2)">No</mat-checkbox>
              </div>
              @if (assessmentForm.get('recruitmentQuestionnaires_2')?.value === true) {
              <div class="mt-2">
                <mat-label>If Yes, please state which type of scheme:</mat-label>
                <mat-form-field class="w-100">
                  <input matInput formControlName="recruitmentQuestionnairesyes_2" placeholder="Enter scheme" />
                  @if(this.assessmentForm.controls["recruitmentQuestionnairesyes_2"].invalid
                  && (this.assessmentForm.controls["recruitmentQuestionnairesyes_2"].touched)
                  ) {
                  <mat-error>
                    @if(this.assessmentForm.controls["recruitmentQuestionnairesyes_2"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>
              }
            </div>
            @if(this.assessmentForm.controls["recruitmentQuestionnaires_2"].invalid
            && (this.assessmentForm.controls["recruitmentQuestionnaires_2"].touched)
            ) {
            <mat-error>
              @if(this.assessmentForm.controls["recruitmentQuestionnaires_2"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </li>

          <li>
            <div class="row">
              <div class="col-sm-10">
                <span>Is the applicant being briefed not to conduct any sales before the issuance of
                  the PIAS Code, even if MAS has issued the Representative Number?
                </span>
              </div>
              <div class="col-sm-2">
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_3')?.value === true"
                  (change)="onCheckboxChange($event.checked, true,'recruitmentQuestionnaires_3',3)">Yes</mat-checkbox>
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_3')?.value === false"
                  (change)="onCheckboxChange($event.checked, false,'recruitmentQuestionnaires_3',3)">No</mat-checkbox>
              </div>
            </div>
            @if(this.assessmentForm.controls["recruitmentQuestionnaires_3"].invalid
            && (this.assessmentForm.controls["recruitmentQuestionnaires_3"].touched)
            ) {
            <mat-error>
              @if(this.assessmentForm.controls["recruitmentQuestionnaires_3"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </li>

          <li>
            <div class="row">
              <div class="col-sm-10">
                <span>Is the applicant being briefed to terminate his/her existing agency agreements
                  with other insurers before he/she is appointed as a representative of PIAS?</span>
              </div>
              <div class="col-sm-2">
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_4')?.value === true"
                  (change)="onCheckboxChange($event.checked, true,'recruitmentQuestionnaires_4',4)">Yes</mat-checkbox>
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_4')?.value === false"
                  (change)="onCheckboxChange($event.checked, false,'recruitmentQuestionnaires_4',4)">No</mat-checkbox>
              </div>
            </div>
            @if(this.assessmentForm.controls["recruitmentQuestionnaires_4"].invalid
            && (this.assessmentForm.controls["recruitmentQuestionnaires_4"].touched)
            ) {
            <mat-error>
              @if(this.assessmentForm.controls["recruitmentQuestionnaires_4"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </li>

          <li>
            <div class="row">
              <div class="col-sm-10">
                <span>Are the proposed banding details & designation by the recruiting manager agreeable to all 
parties (new representative, recruiting manager, financial services director and PIAS)? </span>
              </div>
              <div class="col-sm-2">
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_5')?.value === true"
                  (change)="onCheckboxChange($event.checked, true,'recruitmentQuestionnaires_5',5)">Yes</mat-checkbox>
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_5')?.value === false"
                  (change)="onCheckboxChange($event.checked, false,'recruitmentQuestionnaires_5',5)">No</mat-checkbox>
              </div>
              @if (assessmentForm.get('recruitmentQuestionnaires_5')?.value === false) {
              <div class="mt-2">
                <mat-label>If No, please state the final proposed banding details & designation (after
                  confirmation with FSD):</mat-label>
                <mat-form-field class="w-100">
                  <input matInput formControlName="recruitmentQuestionnairesno_5" placeholder="Enter scheme" />
                  @if(this.assessmentForm.controls["recruitmentQuestionnairesno_5"].invalid
                  && (this.assessmentForm.controls["recruitmentQuestionnairesno_5"].touched)
                  ) {
                  <mat-error>
                    @if(this.assessmentForm.controls["recruitmentQuestionnairesno_5"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>
              }
            </div>
            @if(this.assessmentForm.controls["recruitmentQuestionnaires_5"].invalid
            && (this.assessmentForm.controls["recruitmentQuestionnaires_5"].touched)
            ) {
            <mat-error>
              @if(this.assessmentForm.controls["recruitmentQuestionnaires_5"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </li>

          <li>
            <div class="row">
              <div class="col-sm-10">
                <span>Is the applicant currently engaged with other gainful employment? </span>
              </div>
              <div class="col-sm-2">
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_6')?.value === true"
                  (change)="onCheckboxChange($event.checked, true,'recruitmentQuestionnaires_6',6)">Yes</mat-checkbox>
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_6')?.value === false"
                  (change)="onCheckboxChange($event.checked, false,'recruitmentQuestionnaires_6',6)">No</mat-checkbox>
              </div>
              @if (assessmentForm.get('recruitmentQuestionnaires_6')?.value === true) {
              <div class="mt-2">
                <mat-label>If Yes, please state them accordingly:</mat-label>
                <mat-form-field class="w-100">
                  <input matInput formControlName="recruitmentQuestionnairesyes_6" placeholder="Enter text" />
                  @if(this.assessmentForm.controls["recruitmentQuestionnairesyes_6"].invalid
                  && (this.assessmentForm.controls["recruitmentQuestionnairesyes_6"].touched)
                  ) {
                  <mat-error>
                    @if(this.assessmentForm.controls["recruitmentQuestionnairesyes_6"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>
              }
            </div>
            @if(this.assessmentForm.controls["recruitmentQuestionnaires_6"].invalid
            && (this.assessmentForm.controls["recruitmentQuestionnaires_6"].touched)
            ) {
            <mat-error>
              @if(this.assessmentForm.controls["recruitmentQuestionnaires_6"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </li>

          <li>
            <div class="row">
              <div class="col-sm-10">
                <span><b>[Honesty, Integrity & Reputation]</b><br />Is the applicant currently
                  conducting any of the following prohibited non-FA activities?
                </span>
                <ul class="ack-list">
                  <li>Other regulated licenses (eg. real estate, money lending)</li>
                  <li>Promoting junkets for casinos</li>
                  <li>
                    Marketing products that are not regulated under the Financial Advisers Act
                  </li>
                </ul>
              </div>
              <div class="col-sm-2">
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_7')?.value === true"
                  (change)="onCheckboxChange($event.checked, true,'recruitmentQuestionnaires_7',7)">Yes</mat-checkbox>
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_7')?.value === false"
                  (change)="onCheckboxChange($event.checked, false,'recruitmentQuestionnaires_7',7)">No</mat-checkbox>
              </div>
            </div>
            @if(this.assessmentForm.controls["recruitmentQuestionnaires_7"].invalid
            && (this.assessmentForm.controls["recruitmentQuestionnaires_7"].touched)
            ) {
            <mat-error>
              @if(this.assessmentForm.controls["recruitmentQuestionnaires_7"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </li>

          <li>
            <div class="row">
              <div class="col-sm-10">
                <span>Does the applicant has an existing enhanced introducer agreement with Precepts
                  Legacy?
                </span>
              </div>
              <div class="col-sm-2">
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_8')?.value === true"
                  (change)="onCheckboxChange($event.checked, true,'recruitmentQuestionnaires_8',8)">Yes</mat-checkbox>
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_8')?.value === false"
                  (change)="onCheckboxChange($event.checked, false,'recruitmentQuestionnaires_8',8)">No</mat-checkbox>
              </div>
            </div>
            @if(this.assessmentForm.controls["recruitmentQuestionnaires_8"].invalid
            && (this.assessmentForm.controls["recruitmentQuestionnaires_8"].touched)
            ) {
            <mat-error>
              @if(this.assessmentForm.controls["recruitmentQuestionnaires_8"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </li>

          <li>
            <div class="row">
              <div class="col-sm-10">
                <span><b>[Applicable for applicant who is certified in Health Insurance before 1 Nov
                    2015]</b><br />Has the applicant passed Medishield Life Test?
                </span>
              </div>
              <div class="col-sm-2">
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_9')?.value === true"
                  (change)="onCheckboxChange($event.checked, true,'recruitmentQuestionnaires_9',9)">Yes</mat-checkbox>
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_9')?.value === false"
                  (change)="onCheckboxChange($event.checked, false,'recruitmentQuestionnaires_9',9)">No</mat-checkbox>
              </div>
              @if (assessmentForm.get('recruitmentQuestionnaires_9')?.value === true) {
              <div class="row g-3">
                <mat-label>If Yes, please provide:</mat-label>
                <div class="mt-2">
                  <mat-form-field class="w-100">
                    <!-- <mat-label>Passed date</mat-label> -->
                    <input matInput formControlName="recruitmentQuestionnairesyes_9_1" [matDatepicker]="picker"
                      placeholder=" Enter the Passed date" />
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    @if(this.assessmentForm.controls["recruitmentQuestionnairesyes_9_1"].invalid
                    && (this.assessmentForm.controls["recruitmentQuestionnairesyes_9_1"].touched)
                    ) {
                    <mat-error>
                      @if(this.assessmentForm.controls["recruitmentQuestionnairesyes_9_1"].errors?.["required"]) {
                      <span>{{message}}</span>
                      }
                      @else {
                      <span></span>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="mt-2">
                  <mat-form-field class="w-100">
                    <input matInput formControlName="recruitmentQuestionnairesyes_9_2"
                      placeholder=" Enter the Name of Insurer" />
                    <mat-datepicker #picker></mat-datepicker>
                    @if(this.assessmentForm.controls["recruitmentQuestionnairesyes_9_2"].invalid
                    && (this.assessmentForm.controls["recruitmentQuestionnairesyes_9_2"].touched)
                    ) {
                    <mat-error>
                      @if(this.assessmentForm.controls["recruitmentQuestionnairesyes_9_2"].errors?.["required"]) {
                      <span>{{message}}</span>
                      }
                      @else {
                      <span></span>
                      }
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <p class="note">
                  (The applicant is required to provide a proof of date passed with the insurer.
                  If there is no proof, the applicant is required to declare it on the application
                  form under “additional declaration”.)
                </p>
              </div>
              }@else if(assessmentForm.get('recruitmentQuestionnaires_9')?.value === false){
              <div class="mt-2">
                <mat-label>If No, please provide reason(s):</mat-label>
                <mat-form-field class="w-100">
                  <input matInput formControlName="recruitmentQuestionnairesno_9" placeholder="Enter reason" />
                  @if(this.assessmentForm.controls["recruitmentQuestionnairesno_9"].invalid
                  && (this.assessmentForm.controls["recruitmentQuestionnairesno_9"].touched)
                  ) {
                  <mat-error>
                    @if(this.assessmentForm.controls["recruitmentQuestionnairesno_9"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>
              }
            </div>
            @if(this.assessmentForm.controls["recruitmentQuestionnaires_9"].invalid
            && (this.assessmentForm.controls["recruitmentQuestionnaires_9"].touched)
            ) {
            <mat-error>
              @if(this.assessmentForm.controls["recruitmentQuestionnaires_9"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </li>

          <li>
            <div class="row">
              <div class="col-sm-10">
                <span>Does the applicant has any business interest?</span>
              </div>
              <div class="col-sm-2">
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_10')?.value === true"
                  (change)="onCheckboxChange($event.checked, true,'recruitmentQuestionnaires_10',10)">Yes</mat-checkbox>
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_10')?.value === false"
                  (change)="onCheckboxChange($event.checked, false,'recruitmentQuestionnaires_10',10)">No</mat-checkbox>
              </div>
            </div>
            @if(this.assessmentForm.controls["recruitmentQuestionnaires_10"].invalid
            && (this.assessmentForm.controls["recruitmentQuestionnaires_10"].touched)
            ) {
            <mat-error>
              @if(this.assessmentForm.controls["recruitmentQuestionnaires_10"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </li>

          <li>
            <div class="row">
              <div class="col-sm-10">
                <span>Does the applicant has any outstanding Medisave/other liabilities?</span>
              </div>
              <div class="col-sm-2">
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_11')?.value === true"
                  (change)="onCheckboxChange($event.checked, true,'recruitmentQuestionnaires_11',11)">Yes</mat-checkbox>
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_11')?.value === false"
                  (change)="onCheckboxChange($event.checked, false,'recruitmentQuestionnaires_11',11)">No</mat-checkbox>
              </div>
            </div>
            @if(this.assessmentForm.controls["recruitmentQuestionnaires_11"].invalid
            && (this.assessmentForm.controls["recruitmentQuestionnaires_11"].touched)
            ) {
            <mat-error>
              @if(this.assessmentForm.controls["recruitmentQuestionnaires_11"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </li>

          <li>
            <div class="row">
              <div class="col-sm-10"><span>Does the applicant has any criminal records?</span></div>
              <div class="col-sm-2">
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_12')?.value === true"
                  (change)="onCheckboxChange($event.checked, true,'recruitmentQuestionnaires_12',12)">Yes</mat-checkbox>
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_12')?.value === false"
                  (change)="onCheckboxChange($event.checked, false,'recruitmentQuestionnaires_12',12)">No</mat-checkbox>
              </div>
            </div>
            @if(this.assessmentForm.controls["recruitmentQuestionnaires_12"].invalid
            && (this.assessmentForm.controls["recruitmentQuestionnaires_12"].touched)
            ) {
            <mat-error>
              @if(this.assessmentForm.controls["recruitmentQuestionnaires_12"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </li>

          <li>
            <div class="row">
              <div class="col-sm-10">
                <span>Are there any Letter(s) of Warning issued by previous employers?</span>
              </div>
              <div class="col-sm-2">
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_13')?.value === true"
                  (change)="onCheckboxChange($event.checked, true,'recruitmentQuestionnaires_13',13)">Yes</mat-checkbox>
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_13')?.value === false"
                  (change)="onCheckboxChange($event.checked, false,'recruitmentQuestionnaires_13',13)">No</mat-checkbox>
              </div>
            </div>
            @if(this.assessmentForm.controls["recruitmentQuestionnaires_13"].invalid
            && (this.assessmentForm.controls["recruitmentQuestionnaires_13"].touched)
            ) {
            <mat-error>
              @if(this.assessmentForm.controls["recruitmentQuestionnaires_13"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </li>

          <li>
            <div class="row">
              <div class="col-sm-10"><span>Is there any other declaration?</span></div>
              <div class="col-sm-2">
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_14')?.value === true"
                  (change)="onCheckboxChange($event.checked, true,'recruitmentQuestionnaires_14',14)">Yes</mat-checkbox>
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_14')?.value === false"
                  (change)="onCheckboxChange($event.checked, false,'recruitmentQuestionnaires_14',14)">No</mat-checkbox>
              </div>
            </div>
            @if(this.assessmentForm.controls["recruitmentQuestionnaires_14"].invalid
            && (this.assessmentForm.controls["recruitmentQuestionnaires_14"].touched)
            ) {
            <mat-error>
              @if(this.assessmentForm.controls["recruitmentQuestionnaires_14"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </li>
          <h5 class="field-title">DM Assessment Checklist</h5>
          <li>
            <div class="row">
              <div class="col-sm-10">
                <span>Does recruiting the candidate exceed Team Leader’s SOC? <br />
                  LIA Guideline: 1: 10: 15 unless SOC deviation is given
                </span>
              </div>
              <div class="col-sm-2">
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_15')?.value === true"
                  (change)="onCheckboxChange($event.checked, true,'recruitmentQuestionnaires_15',15)">Yes</mat-checkbox>
                <mat-checkbox [disabled]="this.isReadOnly()"
                  [checked]="assessmentForm.get('recruitmentQuestionnaires_15')?.value === false"
                  (change)="onCheckboxChange($event.checked, false,'recruitmentQuestionnaires_15',15)">No</mat-checkbox>
              </div>
              @if (assessmentForm.get('recruitmentQuestionnaires_15')?.value === true) {
              <div class="mt-2">
                <mat-label>If Yes, highlight what is allowed to be deviated and period of deviation in
                  assessment</mat-label>
                <mat-form-field class="w-100">
                  <input matInput formControlName="recruitmentQuestionnairesyes_15" placeholder="Enter text" />
                  @if(this.assessmentForm.controls["recruitmentQuestionnairesyes_15"].invalid
                  && (this.assessmentForm.controls["recruitmentQuestionnairesyes_15"].touched)
                  ) {
                  <mat-error>
                    @if(this.assessmentForm.controls["recruitmentQuestionnairesyes_15"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>
              }
            </div>
            @if(this.assessmentForm.controls["recruitmentQuestionnaires_15"].invalid
            && (this.assessmentForm.controls["recruitmentQuestionnaires_15"].touched)
            ) {
            <mat-error>
              @if(this.assessmentForm.controls["recruitmentQuestionnaires_15"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </li>
          <h5 class="field-title">Additional Documents</h5>
          <li>
            <div class="row">
              <div class="col-sm-7">
                <span>Medisave Payable Statement by CPF Board</span>
              </div>
              <div class="col-sm-5 text-end">
                @if(isReadOnly() == false){
                <!-- Upload Button -->
                <label class="upload-btn"
                  *ngIf="!this.assessmentForm.get('medisavePayableStatementbyCPFBoardfileName')?.value">
                  Upload Document

                  <input type="file" id="medisavePayableStatementbyCPFBoardfileName" accept=".pdf,.jpg,.jpeg,.png"
                    hidden
                    (change)="onDocumentFileChange($event,'medisavePayableStatementbyCPFBoardfileName','medisavePayableStatementbyCPFBoard')" />
                </label>
                }
                <input type="text" formControlName="medisavePayableStatementbyCPFBoardfileName" hidden>

                @if (this.assessmentForm.get('medisavePayableStatementbyCPFBoardfileName')?.value) {
                <!-- Uploaded File Name -->
                <div class="file-container"
                  *ngIf="this.assessmentForm.get('medisavePayableStatementbyCPFBoardfileName')?.value">
                  @if(isReadOnly() == false){
                  <span class="file-name">{{
                    this.assessmentForm.get('medisavePayableStatementbyCPFBoardfileName')?.value
                    }}</span>

                  <button mat-icon-button color="warn" class="delete-btn"
                    (click)="removeFile('medisavePayableStatementbyCPFBoardfileName','medisavePayableStatementbyCPFBoard')">✖</button>
                  <button mat-icon-button color="primary" class="delete-btn" (click)="previewDoc('medisavePayableStatementbyCPFBoard')">
                  <mat-icon>visibility</mat-icon>
                  </button>
                  }
                </div>

                <!-- </span> -->
                }
                @if(isReadOnly() == true){
                <!-- @let document = documents.at(i).get('file'); -->
                <!-- (click)="previewDoc(document,i)" -->
                @if(this.assessmentForm.get('medisavePayableStatementbyCPFBoardfileName')?.value == ''){
                <button mat-stroked-button [disabled]="true">
                  N/A
                </button>
                }@else{
                <button mat-stroked-button (click)="previewDoc('medisavePayableStatementbyCPFBoard')">
                  View
                </button>
                }
                }
              </div>
              @if(this.assessmentForm.controls["medisavePayableStatementbyCPFBoardfileName"].invalid
              && (this.assessmentForm.controls["medisavePayableStatementbyCPFBoardfileName"].touched ||
              this.assessmentForm.controls["medisavePayableStatementbyCPFBoardfileName"].dirty)
              ) {
              <mat-error>
                @if(this.assessmentForm.controls["medisavePayableStatementbyCPFBoardfileName"].errors?.["required"]) {
                <span>{{message}}</span>
                }
                @else if(this.assessmentForm.controls["medisavePayableStatementbyCPFBoardfileName"].errors?.['invalidType']){
                <span>Only PDF, JPG, PNG files are allowed.</span>
                }
                @else if(this.assessmentForm.controls["medisavePayableStatementbyCPFBoardfileName"].errors?.['maxSize']){
                <span>File size must be less than or equal to 5MB.</span>
                }
                @else {
                <span></span>
                }
              </mat-error>
              }
            </div>
          </li>
          <li>
            <div class="row">
              <div class="col-sm-7">
                <span>Adviser Agreement</span>
              </div>
              <div class="col-sm-5 text-end">
                @if(isReadOnly() == false){
                <!-- Upload Button -->
                <label class="upload-btn" *ngIf="!this.assessmentForm.get('adviserAgreementfileName')?.value">
                  Upload Document

                  <input type="file" id="adviserAgreementfileName" accept=".pdf,.jpg,.jpeg,.png" hidden
                    (change)="onDocumentFileChange($event,'adviserAgreementfileName','adviserAgreement')" />
                </label>
                }
                <input type="text" formControlName="adviserAgreementfileName" hidden>

                @if (this.assessmentForm.get('adviserAgreementfileName')?.value) {
                <!-- Uploaded File Name -->
                <div class="file-container" *ngIf="this.assessmentForm.get('adviserAgreementfileName')?.value">
                  @if(isReadOnly() == false){
                  <span class="file-name">{{ this.assessmentForm.get('adviserAgreementfileName')?.value }}</span>

                  <button mat-icon-button color="warn" class="delete-btn"
                    (click)="removeFile('adviserAgreementfileName','adviserAgreement')">✖</button>
                  <button mat-icon-button color="primary" class="delete-btn" (click)="previewDoc('adviserAgreement')">
                    <mat-icon>visibility</mat-icon>
                  </button>  
                  }
                </div>

                <!-- </span> -->
                }
                @if(isReadOnly() == true){
                <!-- @let document = documents.at(i).get('file'); -->
                @if(this.assessmentForm.get('adviserAgreementfileName')?.value == ''){
                <button mat-stroked-button [disabled]="true">
                  N/A
                </button>
                }@else{
                <button mat-stroked-button (click)="previewDoc('adviserAgreement')">
                  View
                </button>
                }
                }
              </div>
              @if(this.assessmentForm.controls["adviserAgreementfileName"].invalid
              && (this.assessmentForm.controls["adviserAgreementfileName"].touched ||
              this.assessmentForm.controls["adviserAgreementfileName"].dirty)
              ) {
              <mat-error>
                @if(this.assessmentForm.controls["adviserAgreementfileName"].errors?.["required"]) {
                <span>{{message}}</span>
                }@else if(this.assessmentForm.controls["adviserAgreementfileName"].errors?.['invalidType']){
                <span>Only PDF, JPG, PNG files are allowed.</span>
                }
                @else if(this.assessmentForm.controls["adviserAgreementfileName"].errors?.['maxSize']){
                <span>File size must be less than or equal to 5MB.</span>
                }
                @else {
                <span></span>
                }
              </mat-error>
              }
            </div>
          </li>
          <li>
            <div class="row">
              <div class="col-sm-7">
                <span>CDO Approval</span>
              </div>
              <div class="col-sm-5 text-end">
                @if(isReadOnly() == false){
                <!-- Upload Button -->
                <label class="upload-btn" *ngIf="!this.assessmentForm.get('cdoApprovalfileName')?.value">
                  Upload Document

                  <input type="file" id="cdoApprovalfileName" accept=".pdf,.jpg,.jpeg,.png" hidden
                    (change)="onDocumentFileChange($event,'cdoApprovalfileName','cdoApproval')" />
                </label>
                }
                <input type="text" formControlName="cdoApprovalfileName" hidden>

                @if (this.assessmentForm.get('cdoApprovalfileName')?.value) {
                <!-- Uploaded File Name -->
                <div class="file-container" *ngIf="this.assessmentForm.get('cdoApprovalfileName')?.value">
                  @if(isReadOnly() == false){
                  <span class="file-name">{{ this.assessmentForm.get('cdoApprovalfileName')?.value }}</span>

                  <button mat-icon-button color="warn" class="delete-btn"
                    (click)="removeFile('cdoApprovalfileName','cdoApproval')">✖</button>
                  <button mat-icon-button color="primary" class="delete-btn" (click)="previewDoc('cdoApproval')">
                    <mat-icon>visibility</mat-icon>
                  </button>  
                  }
                </div>

                <!-- </span> -->
                }
                @if(isReadOnly() == true){
                <!-- @let document = documents.at(i).get('file'); -->
                @if(this.assessmentForm.get('cdoApprovalfileName')?.value == ''){
                <button mat-stroked-button [disabled]="true">
                  N/A
                </button>
                }@else{
                <button mat-stroked-button (click)="previewDoc('cdoApproval')">
                  View
                </button>
                }
                }
              </div>
              @if(this.assessmentForm.controls["cdoApprovalfileName"].invalid
              && (this.assessmentForm.controls["cdoApprovalfileName"].touched ||
              this.assessmentForm.controls["cdoApprovalfileName"].dirty)
              ) {
              <mat-error>
                @if(this.assessmentForm.controls["cdoApprovalfileName"].errors?.["required"]) {
                <span>{{message}}</span>
                }@else if(this.assessmentForm.controls["cdoApprovalfileName"].errors?.['invalidType']){
                <span>Only PDF, JPG, PNG files are allowed.</span>
                }
                @else if(this.assessmentForm.controls["cdoApprovalfileName"].errors?.['maxSize']){
                <span>File size must be less than or equal to 5MB.</span>
                }
                @else {
                <span></span>
                }
              </mat-error>
              }
            </div>
          </li>
        </ol>

        <!-- Other Attachments -->
        <div class="section-card other-attachments-card">
          <div class="section-header">
            <mat-icon>attach_file</mat-icon>
            <span>Other Attachments</span>
          </div>
          <div class="container-fluid">
            <div class="row g-3">
              @for(key of otherAttachmentKeys; track key){
              <div class="col-md-6">
                <div class="upload-container">
                  <div class="upload-box">
                    <input type="file" [disabled]="isReadOnly()" [id]="key + 'fileName'" accept=".pdf,.jpg,.jpeg,.png"
                      (change)="onDocumentFileChange($event, key + 'fileName', key)">
                    <input type="text" [formControlName]="key + 'fileName'" hidden>

                    <!-- Show filename OR placeholder -->
                    @if(!this.assessmentForm.get(key + 'fileName')?.value){
                    <span>
                      Choose file
                    </span>
                    }
                    @if(this.assessmentForm.get(key + 'fileName')?.value){
                    <div class="attachment-row">
                      <span class="file-name">
                        {{ this.assessmentForm.get(key + 'fileName')?.value }}
                      </span>
                      @if(isReadOnly() === false){
                      <button mat-icon-button color="primary" class="delete-btn"
                        (click)="removeFile(key + 'fileName', key)">
                        <mat-icon>close</mat-icon>
                      </button>
                      }
                    <button mat-icon-button color="primary" class="delete-btn" (click)="previewAttachment(key, key + 'fileName')">
                    <mat-icon>visibility</mat-icon>
                    </button>
                    </div>
                    }
                  </div>
                  @if(isReadOnly() === false){
                  @if(!$first){
                  @if(!this.assessmentForm.get(key + 'fileName')?.value){ 
                  <button type="button" class="icon-btn row-action-btn remove-attachment-btn"
                    matTooltip="Remove this attachment field" (click)="removeOtherAttachment(key)">
                    <mat-icon>close</mat-icon>
                  </button>
                  }
                  }
                  @if($last){
                  <button type="button" class="icon-btn row-action-btn add-attachment-btn"
                    matTooltip="Add another attachment" (click)="addOtherAttachment()">
                    <mat-icon>add</mat-icon>
                  </button>
                  }
                  }
                </div>
                @if(this.assessmentForm.get(key + 'fileName')?.invalid
                && (this.assessmentForm.get(key + 'fileName')?.touched ||
                this.assessmentForm.get(key + 'fileName')?.dirty)
                ) {
                <mat-error>
                  @if(this.assessmentForm.get(key + 'fileName')?.errors?.['invalidType']){
                  <span>Only PDF, JPG, PNG files are allowed.</span>
                  }
                  @else if(this.assessmentForm.get(key + 'fileName')?.errors?.['maxSize']){
                  <span>File size must be less than or equal to 5MB.</span>
                  }
                  @else {
                  <span></span>
                  }
                </mat-error>
                }
              </div>
              }
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <h5 class="field-title">Remarks</h5>
          </div>
          <mat-label class="field-label"></mat-label>
          <mat-form-field class="text-field">

            <textarea matInput formControlName="remarks" placeholder="Enter text"></textarea>
          </mat-form-field>
        </div>
        <!-- <h5 class="field-title">BDM Assessment</h5> -->

        <h5 class="field-title">Acknowledgement</h5>
        <div class="bdm-container container-fluid">
          <div class="col-12">
            <span>I have checked and confirmed with candidate that the information declared in the
              application form is true and accurate. <br />I have informed and briefed the candidate
              on the Company Standards, LIA Guidelines (CPD and PDPA fulfilment) and MAS Regulations
              (Fit and Proper, Honesty, Integrity, Competency and Capability and Financial
              Soundness)<br />The candidate is reminded not to call MAS unnecessarily. For any
              clarifications, please get back to us first.
            </span>
            <p class="note">
              Please be reminded to update your Vaccination Status as per your
              <b>records on TraceTogether App</b> through the
              <i>Vaccination Status Declaration Form.</i> <br />
              False respond will result in breach of Fit and Proper. Disciplinary Actions will be
              taken against you.<br />
              Should your respond be “No”, It is your duty to update your latest status of your
              vaccination via this form
              <b>after you are fully vaccinated as per TraceTogether App.</b>
            </p>
          </div>

          <div class="row align-items-start">
            <mat-checkbox formControlName="declarationaccepted"
              [checked]="assessmentForm.get('declarationaccepted')?.value === true">I agree to the above
              declaration</mat-checkbox>
            <div class="col-md-6">
              <label class="field-label">
                <!-- <mat-icon class="label-icon">store</mat-icon> -->
                Name of DM
              </label>

              <mat-form-field class="w-100">
                <input matInput formControlName="bdmname" placeholder="Enter Name" readonly />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <label class="field-label">
                <!-- <mat-icon class="label-icon">store</mat-icon> -->
                Date
              </label>
              <mat-form-field class="w-100">
                <input type="date" matInput formControlName="date" placeholder="Enter Name" readonly />
              </mat-form-field>
            </div>
          </div>
          @if(this.errormessage != ''){
          <mat-error>

            <span>{{errormessage}}</span>
          </mat-error>
          }
        </div>
        @if(isReadOnly() == false){
        <div class="form-actions mt-4">
          <button type="button" class="save-btn" (click)="saveAndContinue()">
            <span>Save</span>
          </button>
          <button type="button" class="save-btn" (click)="openConfirmDialog()" [disabled]="assessmentForm.invalid">
            <span>Submit</span>
          </button>
        </div>
        }
      </div>
    </div>
  </div>
  @if (showPreview) {
  <div class="preview-backdrop" appDocumentPreviewOverlay (dismiss)="closePreview()">
    <div class="preview-panel" role="dialog" aria-modal="true" aria-label="Document preview">

      <div class="preview-header d-flex justify-content-between align-items-center p-3 border-bottom">
        <div class="d-flex flex-column">
          <span class="fw-bold fs-5">Document Preview</span>
          <small class="text-muted">{{ currentFileName }}</small>
        </div>
        <div class="preview-header-actions">
          @if (!isPdf) {
          <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= MIN_ZOOM" title="Zoom out">
            <mat-icon>zoom_out</mat-icon>
          </button>
          <span class="zoom-level">{{ zoomLevel * 100 }}%</span>
          <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= MAX_ZOOM" title="Zoom in">
            <mat-icon>zoom_in</mat-icon>
          </button>
          }
          <button mat-icon-button color="warn" (click)="closePreview()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <!-- Preview Content -->
      <div class="preview-content">
        @if (isPdf) {
        <!-- <embed [src]="pdfUrl"  width="100%" height="600px" /> -->
        <iframe [src]="selectedDocument" width="100%" height="100%"></iframe>

        } @else {
        <img [src]="selectedDocument" alt="Document Preview" class="preview-image"
          [style.transform]="'scale(' + zoomLevel + ')'" />
        }
      </div>

    </div>
  </div>
  }
</div>